import * as Yup from 'yup';
import {
  Stack,
  Paper,
  Typography,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { Flow, Menu } from '@/types/menus';
import { MediaManager } from '@/components';
import InputText from '@/components/InputText';
import { useFormikContext } from 'formik';

const MenuDetailsTab = () => {
  const { values, handleChange, errors, setFieldValue } =
    useFormikContext<Menu>();

  return (
    <Stack gap={2}>
      <Paper sx={{ padding: 2 }}>
        <Typography variant="h4">Detalles</Typography>
        <InputText
          label="Nombre"
          margin="normal"
          name="title"
          size="small"
          editMode={true}
        />
        <InputText
          label="Descripción"
          margin="dense"
          name="description"
          size="small"
          multiline
          rows={3}
          editMode={true}
        />
      </Paper>
      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          <Typography variant="h4">Foto de portada</Typography>
          <MediaManager
            value={
              Array.isArray(values?.image) ? values.image[0] : values?.image
            }
            onChange={(value: Menu['image']) => {
              setFieldValue('image', value[0]);
            }}
            helperText={errors?.image as string | undefined}
          />
        </Stack>
      </Paper>
      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          <Typography variant="h4">Flujos</Typography>
          <Stack>
            <FormControlLabel
              label="Dine In"
              labelPlacement="start"
              sx={{
                margin: 0,
                display: 'flex',
                justifyContent: 'space-between',
              }}
              control={
                <Switch
                  name={Flow.DINE_IN}
                  checked={(values?.flow ?? []).includes(Flow.DINE_IN)}
                  onChange={(e: {
                    target: { name: string; checked: boolean };
                  }) => {
                    const draft = values?.flow ? [...values.flow] : [];
                    const index = draft.findIndex(
                      (f: string) => f === e.target.name
                    );

                    if (index >= 0) {
                      draft.splice(index, 1);
                    } else {
                      draft.push(e.target.name as Flow);
                    }

                    setFieldValue('flow', draft);
                  }}
                />
              }
            />
            <FormControlLabel
              label="Delivery"
              labelPlacement="start"
              sx={{
                margin: 0,
                display: 'flex',
                justifyContent: 'space-between',
              }}
              control={
                <Switch
                  name={Flow.DELIVERY}
                  checked={(values?.flow ?? []).includes(Flow.DELIVERY)}
                  onChange={(e: {
                    target: { name: string; checked: boolean };
                  }) => {
                    const draft = values?.flow ? [...values.flow] : [];
                    const index = draft.findIndex(
                      (f: string) => f === e.target.name
                    );

                    if (index >= 0) {
                      draft.splice(index, 1);
                    } else {
                      draft.push(e.target.name as Flow);
                    }

                    setFieldValue('flow', draft);
                  }}
                />
              }
            />
          </Stack>
        </Stack>
      </Paper>
      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          <Typography variant="h4">Estado</Typography>
          <Stack>
            <FormControlLabel
              label="Publicado"
              labelPlacement="start"
              sx={{
                margin: 0,
                display: 'flex',
                justifyContent: 'space-between',
              }}
              control={
                <Switch
                  name="isPublished"
                  checked={values.isPublished}
                  onChange={handleChange}
                />
              }
            />
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default MenuDetailsTab;

export const MenuDetailsSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, 'Muy corto, ingresa al menos 3 caracteres')
    .max(50, 'Muy largo, máximo 150 caracteres')
    .required('Campo requerido'),
  description: Yup.string()
    .min(15, 'Muy corto, ingresa al menos 50 caracteres')
    .max(150, 'Muy largo, máximo 150 caracteres')
    .required('Campo requerido'),
  organization: Yup.string(),
  flow: Yup.array().of(Yup.string()),
  isPublished: Yup.boolean(),
});
